import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// --- SYSTEM-WEICHE ---
// Globaler Flag für die gesamte App, um lokale Testläufe von Live-Operationen zu trennen.
export const isDevMode = process.env.NODE_ENV === 'development';

// --- UMWELTVARIABLEN-INTEGRATION (ENV-SHIELD) ---
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // Bucket-Name exakt aus ENV — bei preisexpert-online existiert nur
  // *.firebasestorage.app (*.appspot.com → 404).
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    (process.env.REACT_APP_FIREBASE_PROJECT_ID
      ? `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebasestorage.app`
      : undefined),
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// --- BULLETPROOF INITIALISIERUNG ---
// Verhindert den "Cannot access before initialization" Crash zu 100%
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// --- APP CHECK (Beobachtungsmodus / non-enforcing auf Client-Seite) ---
// Ohne Site-Key: klarer Hinweis, Auth/Registrierung bleiben unberührt.
// Enforcement wird erst in der Firebase Console aktiviert — bis dahin blockiert nichts.
try {
  const appCheckSiteKey = String(process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY || '').trim();
  if (!appCheckSiteKey) {
    console.info(
      '[App Check] Kein REACT_APP_FIREBASE_APPCHECK_SITE_KEY gesetzt — ' +
      'App Check läuft nicht (Beobachtungsmodus/ohne Client-Token). ' +
      'Anmelden & Registrieren werden nicht blockiert.'
    );
  } else {
    // Debug-Token nur in Dev (Firebase Console → App Check → Manage debug tokens)
    if (isDevMode) {
      (globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN =
        process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN || true;
    }
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
    console.info('[App Check] Client initialisiert (Token-Refresh aktiv). Enforcement nur via Firebase Console.');
  }
} catch (appCheckErr) {
  console.warn(
    '[App Check] Initialisierung fehlgeschlagen — Auth/Registrierung laufen weiter ohne App Check:',
    appCheckErr
  );
}

// Sichere Exporte
const auth = getAuth(app);
// Auth-Mails (Passwort-Reset, Verifizierung) auf Deutsch
auth.languageCode = 'de';
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, "europe-west1");

export { app, auth, db, storage, functions };